var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWufooRocketBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "258px",
    height: "526px",
    viewBox: "0 0 258 526",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.3,244.1 C231.2,156.5 200.6,67.2 136.4,3 C132.5,-0.9 125.6,-0.9 121.7,3 C57.5,67.2 26.9,156.4 34.8,244.1 C12.6,268 0.4,298.8 0.4,331.6 C0.4,364.7 21.1195312,396.2 44.0195312,420.2 C49.6195312,426.1 55.8,423.4 53.5,410.4 C52.3,403.6 50.8,397 50.8,390.5 C50.8,374.3 55.7,358.9 64.8,345.9 C66.3,346.7 68,347.2 69.8,347.2 L188.3,347.2 C190.1,347.2 191.8,346.7 193.3,345.9 C202.4,358.9 207.3,374.3 207.3,390.5 C207.3,397 205.6,403.5 204.6,410.4 C202.5,424.8 209.303906,425.3 214.003906,420.2 C236.803906,396.1 257.7,364.7 257.7,331.6 C257.6,298.8 245.5,267.9 223.3,244.1 Z M129,25.4 C147.6,45.4 162.8,67.9 174.6,91.8 L83.5,91.8 C95.2,67.8 110.4,45.4 129,25.4 Z M31,376.4 C24.6,362.5 21.3,347.3 21.3,331.6 C21.3,310.4 27.4,290.1 38.8,272.7 C38.9,273.5 49.8,315.2 54,325.9 C41.5,340.3 33.6,357.7 31,376.4 Z M181.4,326.3 L76.6,326.3 C47.2,257.3 47.5,180.2 74.2,112.5 L183.8,112.5 C210.5,180.2 210.8,257.3 181.4,326.3 Z M204.1,325.9 C209.9,311 219.2,273.3 219.3,272.7 C230.7,290 236.8,310.3 236.8,331.6 C236.8,347.3 233.4,362.5 227.1,376.4 C224.4,357.7 216.5,340.3 204.1,325.9 Z",
    id: "Shape",
    fill: "#231F20",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,377 C80.9,377 76.3,382.786594 76.3,389.804378 L76.3,454.195622 C76.3,461.336525 81,467 86.7,467 C92.4,467 97.1,461.213406 97.1,454.195622 L97.1,389.804378 C97.1,382.663475 92.4,377 86.7,377 Z",
    id: "Shape",
    fillOpacity: 0.99,
    fill: "#D8625B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,364.100398 C122.1,364.100398 122.1,364.100398 122,364.232669 C120.8,365.81992 119.9,367.936255 119.4,370.317131 C119.2,371.50757 119,372.698008 119,374.020717 C119,404.174284 119,426.78946 119,441.866244 C119,457.505706 119,480.9649 119,512.243825 C119,513.301992 119.1,514.360159 119.3,515.418327 C120.4,521.502789 124.5,526 129.4,526 C134.3,526 138.4,521.502789 139.5,515.418327 C139.7,514.360159 139.8,513.301992 139.8,512.243825 L139.8,373.756175 C139.8,372.433466 139.7,371.243028 139.4,370.05259 C138.3,364.232669 134.3,360 129.5,360 C126.6,360 124,361.587251 122.1,364.100398 Z",
    id: "Shape",
    fill: "#D8625B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,377 C165.3,377 160.7,382.786594 160.7,389.804378 L160.7,454.195622 C160.7,461.336525 165.4,467 171.1,467 C176.8,467 181.5,461.213406 181.5,454.195622 L181.5,389.804378 C181.6,382.663475 176.9,377 171.1,377 Z",
    id: "Shape",
    fill: "#D8625B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,325.9 C209.9,311 219.2,273.3 219.3,272.7 C230.7,290 236.8,310.3 236.8,331.6 C236.8,347.3 233.4,362.5 227.1,376.4 C224.4,357.7 216.5,340.3 204.1,325.9 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,326.3 L76.6,326.3 C47.2,257.3 47.5,180.2 74.2,112.5 L183.8,112.5 C210.5,180.2 210.8,257.3 181.4,326.3 Z",
    id: "Path-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,376.4 C24.6,362.5 21.3,347.3 21.3,331.6 C21.3,310.4 27.4,290.1 38.8,272.7 C38.9,273.5 49.8,315.2 54,325.9 C41.5,340.3 33.6,357.7 31,376.4 Z",
    id: "Path-Copy-2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,25.4 C147.6,45.4 162.8,67.9 174.6,91.8 L83.5,91.8 C95.2,67.8 110.4,45.4 129,25.4 Z",
    id: "Path-Copy-3",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wufoo-Circle_Logo_CMYK",
    transform: "translate(66.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,126 C28.2060367,126 0,97.7939633 0,63 C0,28.2060367 28.2060367,0 63,0 C97.7934501,0 126,28.2060367 126,63 C126,97.7939633 97.7934501,126 63,126 Z",
    id: "Fill-1",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    fill: "#D8625B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7130425,105 L19,47.8214864 L36.2734024,44.0963484 L44.5357052,65.6602693 C47.0987761,72.3912189 49.891696,80.1932225 52.1922284,86.1408488 L52.370489,86.1024506 C51.8050606,79.1267763 51.4996169,71.6283745 51.2646602,64.0219458 L50.3427106,41.0623781 L67.5272381,37.3561831 L76.2477064,59.7546251 C78.7913679,66.3970029 80.9146612,72.3825153 83.1722885,78.9921266 L83.3500383,78.9537284 C82.8040194,72.068162 82.3397246,64.6972422 81.8948392,57.4164303 L80.7052433,34.5142039 L97,31 L95.1310728,94.3427057 L77.5905349,98.1251851 L68.5252932,75.4272371 C66.5046657,70.3540661 64.4968077,64.9035686 62.1625641,57.936598 L61.9848143,57.9749962 C62.537984,65.3259489 62.9430289,71.1220302 63.0242422,76.7066654 L63.5217374,101.159155 L45.7130425,105",
    id: "Fill-2",
    fill: "#FFFFFE"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWufooRocketBoost);
export default __webpack_public_path__ + "static/media/wufoo-rocket-boost.cfcc08a936fa648bfcef3f28b2d98285.svg";
export { ForwardRef as ReactComponent };